module.exports = __webpack_public_path__ + "img/1553779633.6213dd35.jpg";